module.exports = {
          srcSet: __webpack_public_path__ + "7f0b5c64aeba6be377e5d1fa1deaa6dc-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "7f0b5c64aeba6be377e5d1fa1deaa6dc-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "7f0b5c64aeba6be377e5d1fa1deaa6dc-66.jpg",
          toString:function(){return __webpack_public_path__ + "7f0b5c64aeba6be377e5d1fa1deaa6dc-66.jpg"},
          
          width: 66,
          height: 66
        }